// Mock data for Baja Designs India landing page (frontend-only)

export const LINKS = {
  shop: "https://www.motousher.com/collections/baja-designs",
  autoShop: "https://www.motousher.com/collections/aux-led-automobile",
  motoShop: "https://www.motousher.com/collections/auxiliary-lights-for-motorcycles",
  instagram: "http://instagram.com/bajadesigns.in",
};

export const NAV_ITEMS = [
  { label: "Home", to: "/" },
  { label: "Automotive", to: "/automotive" },
  { label: "Motorcycle", to: "/motorcycle" },
];

export const HERO_SLIDES = [
  {
    id: 1,
    image:
      "https://images.unsplash.com/photo-1778942854946-968abff62aab?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHw0fHxvZmZyb2FkJTIwdHJ1Y2slMjBMRUQlMjBuaWdodHxlbnwwfHx8fDE3ODY5NDE4OTF8MA&ixlib=rb-4.1.0&q=85",
    tag: "Night is our territory",
    title: "OWN THE DARK",
    subtitle:
      "Engineered in the desert, proven in the toughest races on earth. Baja Designs is the science of lighting.",
  },
  {
    id: 2,
    image:
      "https://images.unsplash.com/photo-1636138103588-ae927bfe10aa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwxfHxvZmZyb2FkJTIwdHJ1Y2slMjBMRUQlMjBuaWdodHxlbnwwfHx8fDE3ODY5NDE4OTF8MA&ixlib=rb-4.1.0&q=85",
    tag: "Built to conquer",
    title: "SEE MORE. GO FARther.",
    subtitle:
      "From weekend trails to expedition overlanding, light the way with race-bred LED technology.",
  },
  {
    id: 3,
    image:
      "https://images.pexels.com/photos/12585215/pexels-photo-12585215.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600",
    tag: "Race proven",
    title: "DUST. SPEED. LIGHT.",
    subtitle:
      "The lighting choice of champions across the world's most brutal off-road competitions.",
  },
];

export const MARQUEE_WORDS = [
  "LED LIGHT BARS",
  "POD LIGHTS",
  "AUXILIARY LIGHTS",
  "MOTORCYCLE KITS",
  "ROCK LIGHTS",
  "WIRING HARNESSES",
  "RACE PROVEN",
  "OVERLANDING",
];

export const AUTO_HERO =
  "https://images.unsplash.com/photo-1636138103588-ae927bfe10aa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwxfHxvZmZyb2FkJTIwdHJ1Y2slMjBMRUQlMjBuaWdodHxlbnwwfHx8fDE3ODY5NDE4OTF8MA&ixlib=rb-4.1.0&q=85";

export const MOTO_HERO =
  "https://images.unsplash.com/photo-1638406958081-c0ea8fe9c4ce?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

export const AUTOMOTIVE_PRODUCTS = [
  {
    id: "a1",
    name: "LED Light Bars",
    category: "OnX6 / S8 Series",
    desc: "Roof and bumper mounted light bars that throw a wall of light down the trail, from tight spread to long-range spot.",
    image:
      "https://images.pexels.com/photos/14698886/pexels-photo-14698886.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  },
  {
    id: "a2",
    name: "Auxiliary LED Pods",
    category: "LP9 / XL / Squadron",
    desc: "High-output driving and combo pods that light up the night for trucks, Jeeps and UTVs chasing the horizon.",
    image:
      "https://images.pexels.com/photos/11053640/pexels-photo-11053640.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  },
  {
    id: "a3",
    name: "Vehicle-Specific Kits",
    category: "Bolt-On Systems",
    desc: "Complete, no-guesswork lighting kits engineered for specific vehicles like the Jeep Wrangler. Mount and conquer.",
    image:
      "https://images.unsplash.com/photo-1739900225202-5d7b707f2f5c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHw0fHxqZWVwJTIwZGVzZXJ0fGVufDB8fHx8MTc4Njk0MTk1OHww&ixlib=rb-4.1.0&q=85",
  },
];

export const AUTOMOTIVE_GRID = [
  "https://images.unsplash.com/photo-1517962140171-2dfc01caecb7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwxfHxVVFYlMjBvZmZyb2FkfGVufDB8fHx8MTc4Njk0MTk1OHww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1739900225202-5d7b707f2f5c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHw0fHxqZWVwJTIwZGVzZXJ0fGVufDB8fHx8MTc4Njk0MTk1OHww&ixlib=rb-4.1.0&q=85",
  "https://images.pexels.com/photos/11053640/pexels-photo-11053640.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
];

export const MOTORCYCLE_PRODUCTS = [
  {
    id: "m1",
    name: "ADV Auxiliary Lights",
    category: "XL Pro / Squadron",
    desc: "Vibration-tested driving and combo lights for adventure and dual-sport riders who don't slow down after dark.",
    image:
      "https://images.unsplash.com/photo-1638406958081-c0ea8fe9c4ce?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  },
  {
    id: "m2",
    name: "Compact LED Pods",
    category: "S1 / S2 Series",
    desc: "Tiny footprint, enormous output. Bolt-on brightness that transforms naked bikes, cruisers and tourers.",
    image:
      "https://images.unsplash.com/photo-1615398692278-9c12f02e0ec3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  },
  {
    id: "m3",
    name: "LED Headlight Kits",
    category: "Bike-Specific Retrofit",
    desc: "Complete headlight conversions engineered for machines like the KTM ADV range. Turn night into day.",
    image:
      "https://images.unsplash.com/photo-1758550713936-8bffa7ca3485?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  },
];

export const TECHNOLOGY = [
  {
    id: "t1",
    title: "ClearView™",
    desc: "Our signature beam pattern delivers the perfect blend of long-distance punch and wide peripheral spread.",
    icon: "Eye",
  },
  {
    id: "t2",
    title: "MoistureBlock™",
    desc: "A vented, sealed housing that eliminates internal fogging and corrosion — waterproof to depth.",
    icon: "Droplets",
  },
  {
    id: "t3",
    title: "CopperDrive™",
    desc: "LEDs driven at 100% for maximum output and the longest possible lifespan on the trail.",
    icon: "Zap",
  },
  {
    id: "t4",
    title: "uService®",
    desc: "A fully serviceable design. Replace lenses, optics and hardware in the field — never toss a light.",
    icon: "Wrench",
  },
];

export const STATS = [
  { id: "s1", value: "6", suffix: "+", label: "Beam Patterns" },
  { id: "s2", value: "30", suffix: " YRS", label: "Desert Racing DNA" },
  { id: "s3", value: "100", suffix: "%", label: "CopperDrive Output" },
  { id: "s4", value: "IP69K", suffix: "", label: "Sealed & Waterproof" },
];

export const FILMS = [
  {
    id: "f1",
    title: "LP9 Pro & SAE Squadron Install",
    subtitle: "Fog light upgrade walkthrough",
    youtube: "qsM0C6tQJUE",
  },
  {
    id: "f2",
    title: "LP9 & XL80 Field Test",
    subtitle: "Real-world night output",
    youtube: "J-yEL9X9k8U",
  },
  {
    id: "f3",
    title: "Squadron Pro DIY Setup",
    subtitle: "Off-road lighting tutorial",
    youtube: "q0nTG1_Fhak",
  },
  {
    id: "f4",
    title: "The Story of Squadron 2.0",
    subtitle: "Baja Designs University",
    youtube: "11h7MNKup3c",
  },
];

export const AUTO_FILMS = [FILMS[0], FILMS[1]];
export const MOTO_FILMS = [FILMS[2], FILMS[3]];

export const GALLERY = [
  {
    id: "g1",
    image:
      "https://images.unsplash.com/photo-1517962140171-2dfc01caecb7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwxfHxVVFYlMjBvZmZyb2FkfGVufDB8fHx8MTc4Njk0MTk1OHww&ixlib=rb-4.1.0&q=85",
    caption: "UTV — Dune Runner",
    span: "tall",
  },
  {
    id: "g2",
    image:
      "https://images.unsplash.com/photo-1519021228607-ef6e4c22d821?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHw0fHxVVFYlMjBvZmZyb2FkfGVufDB8fHx8MTc4Njk0MTk1OHww&ixlib=rb-4.1.0&q=85",
    caption: "Side-by-Side — Trail Attack",
    span: "wide",
  },
  {
    id: "g3",
    image:
      "https://images.pexels.com/photos/18079831/pexels-photo-18079831.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    caption: "Rally Raid — Full Throttle",
    span: "normal",
  },
  {
    id: "g4",
    image:
      "https://images.unsplash.com/photo-1547235002-edab0f7f1395?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwzfHxqZWVwJTIwZGVzZXJ0fGVufDB8fHx8MTc4Njk0MTk1OHww&ixlib=rb-4.1.0&q=85",
    caption: "4x4 — Desert Crossing",
    span: "normal",
  },
  {
    id: "g5",
    image:
      "https://images.unsplash.com/photo-1615398692278-9c12f02e0ec3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    caption: "ADV Rider — Sand Passage",
    span: "tall",
  },
  {
    id: "g6",
    image:
      "https://images.pexels.com/photos/15887183/pexels-photo-15887183.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    caption: "4x4 — Forest Expedition",
    span: "wide",
  },
  {
    id: "g7",
    image:
      "https://images.unsplash.com/photo-1758550713985-81404eaad1be?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    caption: "ADV — Highland Run",
    span: "normal",
  },
  {
    id: "g8",
    image:
      "https://images.pexels.com/photos/29206472/pexels-photo-29206472.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    caption: "Expedition Truck — Aux Array",
    span: "normal",
  },
];

export const IMAGE_CREDITS = [
  "Photography via Unsplash & Pexels contributors — used for demonstration only.",
  "Vehicle and lighting imagery is representative and not affiliated official product photography.",
];
